module.exports = __webpack_public_path__ + "d308073b/img/note-edit-icon.acae1669.svg";